import styled from 'styled-components'
import { useSession } from "next-auth/react"
import useRequest from '@hooks/useRequest'
import { isRole } from '@utils'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    margin: 16px 0;
`


const Td = styled.td`
    padding: 8px 12px;
    border-bottom: 1px solid #e1e5e9;
    color: #374151;
`

const SubTd = styled(Td)`
    padding-left: 2em;
    font-size: 13px;
    color: #4b5563;
`

const TdValue = styled.td<{ isWarning?: boolean }>`
    padding: 8px 12px;
    border-bottom: 1px solid #e1e5e9;
    text-align: right;
`

const SectionCell = styled.td`
    padding: 12px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e1e5e9;
`

const Warning = styled.span`
    color: #dc2626;
    font-weight: bold;
`

const Placeholder = styled.span`
    width: 1.1em;
    background: #d8d8d8;
    display: inline-block;
    vertical-align: middle;
    height: 0.8em;
    border-radius: 3px;
`

function Number(data: any, prop: string) {
    if (data) {
        const number = data[prop];
        if (number === 0) {
            return <Warning>{number}</Warning>
        }
        return number;
    }
    else {
        return <Placeholder />
    }
}

export default function DbStats() {

    const { data: session } = useSession()

    const { data, error } = useRequest<any>({ url: '/api2/stats/dashboard' }, {
        revalidateIfStale: false,
        revalidateOnFocus: false
    })

    if (error) {
        console.log(error);
        return <div>❌</div>
    }

    const { companies } = data || {};

    return (
        <Table>
            <tbody>
                <tr>
                    <Td>Companies to process</Td>
                    <TdValue isWarning={companies?.open === 0}>
                        {Number(companies, 'open')}
                    </TdValue>
                </tr>
                <tr>
                    <SubTd>🇸🇪 Swedish</SubTd>
                    <TdValue>
                        {Number(companies, 'openSwedishCompanies')}
                    </TdValue>
                </tr>
                <tr>
                    <SubTd>🇫🇮 Finnish</SubTd>
                    <TdValue>
                        {Number(companies, 'openFinnishCompanies')}
                    </TdValue>
                </tr>
                <tr>
                    <SubTd>🇪🇪 Estonian</SubTd>
                    <TdValue>
                        {Number(companies, 'openEstonianCompanies')}
                    </TdValue>
                </tr>

                <tr>
                    <SectionCell colSpan={2}></SectionCell>
                </tr>

                <tr>
                    <Td>Founders</Td>
                    <TdValue>
                        {Number(companies, 'peopleCount')}
                    </TdValue>
                </tr>
                <tr>
                    <Td>
                        LinkedIn Profiles ({Number(companies, 'linkedinProfileCountPercentage')}%)
                    </Td>
                    <TdValue>
                        {Number(companies, 'linkedinProfileCount')}
                    </TdValue>
                </tr>

                {isRole(session, 'dev') &&
                    <>
                        <tr><SectionCell colSpan={2}></SectionCell></tr>
                        <tr>
                            <SectionCell>Unpublished Companies</SectionCell>
                            <TdValue isWarning={companies?.unpublished > 0}>{Number(companies, 'unpublished')}</TdValue>
                        </tr>
                        <tr>
                            <SubTd>🇸🇪 Swedish</SubTd>
                            <TdValue isWarning={companies?.unpublishedSwedishCompanies > 0}>
                                {Number(companies, 'unpublishedSwedishCompanies')}
                            </TdValue>
                        </tr>
                        <tr>
                            <SubTd>🇫🇮 Finnish</SubTd>
                            <TdValue isWarning={companies?.unpublishedFinnishCompanies > 0}>
                                {Number(companies, 'unpublishedFinnishCompanies')}
                            </TdValue>
                        </tr>
                        <tr>
                            <SubTd>🇪🇪 Estonian</SubTd>
                            <TdValue isWarning={companies?.unpublishedEstonianCompanies > 0}>
                                {Number(companies, 'unpublishedEstonianCompanies')}
                            </TdValue>
                        </tr>

                        <tr><SectionCell colSpan={2}></SectionCell></tr>
                        <tr>
                            <SectionCell colSpan={2}>Added Last 10 Days</SectionCell>
                        </tr>
                        <tr>
                            <SubTd>🇸🇪 Swedish</SubTd>
                            <TdValue>
                                {Number(companies, 'last10Days_swedishCompanies')}
                            </TdValue>
                        </tr>
                        <tr>
                            <SubTd>🇫🇮 Finnish</SubTd>
                            <TdValue>
                                {Number(companies, 'last10Days_finnishCompanies')}
                            </TdValue>
                        </tr>
                        <tr>
                            <SubTd>🇪🇪 Estonian</SubTd>
                            <TdValue>
                                {Number(companies, 'last10Days_estonianCompanies')}
                            </TdValue>
                        </tr>
                    </>
                }
            </tbody>
        </Table>
    )
}